import {
  CarbonCreditCustomPrice,
  CarbonCreditInputType, CustomPricePropName
} from '../../../../models/project/ghg-emission/carbon-credit.model';
import { ProjectValidationUnit, ValidationItem } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { ValidationInterface } from '../../validation.interface';

export class CarbonCreditPriceValidation implements ValidationInterface {
  /** The current carbon credit price obj that is being validated */
  ccPrice: CarbonCreditCustomPrice;
  /** The input type of the current carbon credit price */
  inputType: string;

  /**
   * Sets the carbon credit price obj that will be used for validation
   * @param ccPrice will be used to set the current carbon credit price obj
   * @param inputType will be used to set the current input type of the carbon credit price
   */
  constructor(ccPrice: CarbonCreditCustomPrice, inputType: string) {
    if (!ccPrice || !inputType) throw Error('invalid carbon credit price provided for validation');
    this.ccPrice = new CarbonCreditCustomPrice(ccPrice);
    this.inputType = inputType;
  }

  /**
   * Get a validation unit containing the validation data for the current carbon credit price obj
   */
  getValidation(): ProjectValidationUnit {
    const validationUnit = new ProjectValidationUnit();
    if (!this.inputType) {
      validationUnit.setInvalid(this.inputType);
    } else {
      if (this.inputType === CarbonCreditInputType.File && !(validationUnit.tree instanceof ValidationItem)) {
        if (this.ccPrice && this.ccPrice.name) {
          validationUnit.tree['PROJECT.GHG.INPUT_TYPE.FILE'] = true;
          validationUnit.validFields++;
        } else {
          validationUnit.tree['PROJECT.GHG.INPUT_TYPE.FILE'] = false;
          validationUnit.invalidFields++;
          validationUnit.isValid = false;
        }
        if (this.ccPrice && this.ccPrice.price && this.ccPrice.price.unit) {
          validationUnit.tree[('PROJECT.GHG.PRICE' + ', ' + 'PROJECT.GHG.UNIT')] = true;
          validationUnit.validFields++;
        } else {
          validationUnit.tree[('PROJECT.GHG.PRICE' + ', ' + 'PROJECT.GHG.UNIT')] = false;
          validationUnit.invalidFields++;
          validationUnit.isValid = false;
        }
        if (this.ccPrice && this.ccPrice.price && this.ccPrice.pricePer.unit) {
          validationUnit.tree[('PROJECT.GHG.PRICE_PER' + ', ' + 'PROJECT.GHG.UNIT')] = true;
          validationUnit.validFields++;
        } else {
          validationUnit.tree[('PROJECT.GHG.PRICE_PER' + ', ' + 'PROJECT.GHG.UNIT')] = false;
          validationUnit.invalidFields++;
          validationUnit.isValid = false;
        }
      } else {
        validationUnit.addModuleResults(
          new UnitValueValidation(this.ccPrice.price).getValidation(),
          CustomPricePropName.price
        );
        validationUnit.addModuleResults(
          new UnitValueValidation(this.ccPrice.pricePer).getValidation(),
          CustomPricePropName.pricePer
        );
      }

    }
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current carbon credit price obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
